import React from 'react'
import { reducer, initialState } from './reducer'

export const NotificationCriteriaContext = React.createContext({
  notificationCriteriaState: initialState,
  notificationCriteriaDispatch: () => null,
})

export const NotificationsProvider = ({ children }) => {
  const [notificationCriteriaState, notificationCriteriaDispatch] =
    React.useReducer(reducer, initialState)

  return (
    <NotificationCriteriaContext.Provider
      value={[notificationCriteriaState, notificationCriteriaDispatch]}
    >
      {children}
    </NotificationCriteriaContext.Provider>
  )
}
